export const formatDateTime = (
  date?: Date | number,
  locale?: string,
): string | undefined => {
  if (!date) return;
  if (typeof date === "number") date = new Date(date);
  return date.toLocaleDateString(locale, {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

export const formatTime = (
  date?: Date | number,
  locale?: string,
): string | undefined => {
  if (!date) return;
  if (typeof date === "number") date = new Date(date);
  return date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (
  date?: Date | number,
  locale?: string,
): string | undefined => {
  if (!date) return;
  if (typeof date === "number") date = new Date(date);
  return date.toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const DateTimeUtils = {
  formatDate,
  formatDateTime,
  formatTime,
};

export default DateTimeUtils;
